import React from 'react'

const ServicesCard = ({ icon, title, text }) => {
    return (
        <div className='services_card'>

            <div className='services_cardIcon'>
                <i class={icon}></i>
            </div>

            <h2>{title}</h2>
            
            <p>{text}</p>
        </div>
    )
}

export default ServicesCard
